<template>
  <div style="display: flex; font-size: 12px; align-items: center; height: 21px">
    <div style="width: 54px; text-align: right;">
      {{label}}
    </div>
    <div style="margin-left: 15px; flex-grow: 1">
      <div v-if="type === 'id'">
        {{work.extraId || work.id}}
      </div>
      <div v-if="type === 'carNo'">
        {{work.carNo | carNo}}
      </div>
      <template v-else-if="type === 'progress'">
        <el-progress v-if="work.progress <= 100" :text-inside="true" :stroke-width="17"
                     :percentage="work.progress"
                     style="display:block; margin: auto 18px auto 2px;"></el-progress>
        <div v-else style="color: red">超时</div>
      </template>
      <div v-else-if="type === 'color'"
           style="border: 1px solid black; box-sizing:border-box; margin: auto 20px auto 2px; height: 17px"
           :style="{backgroundColor: work.color}">
      </div>
      <div v-else-if="type === 'paintArea'">{{work[type]}}</div>
      <!--https://www.cnblogs.com/gopark/p/8875655.html-->
      <div v-else-if="type === 'brandModel'" style="width: 107px; text-overflow:ellipsis; overflow: hidden; white-space: nowrap">
        {{work.brandName}} / {{work.model}}
      </div>
      <div v-else-if="type === 'durationInFactory'">{{durationInFactory}}</div>
      <div v-else-if="type.endsWith('Time')">{{work[type].split(' ')[0]}}</div>
      <!-- <div v-else-if="type === 'status'" v-loading="$isLoading('WorkStatus')"
           :style="{'color': work.status === 'MACHINE_REPAIR_WAIT' ? 'red' :work.status ==='INTERRUPT'?'red':'black'}">
        {{work.status | valueName('WorkStatus')}}
      </div> -->
      <div v-else>{{work[type]}}</div>
    </div>
  </div>
</template>

<script>
  import { shareDataMixin } from '@/views/mixins/ShareData'

  export default {
    name: 'WorkCardItem',
    mixins: [shareDataMixin],
    props: {
      work: Object,
      type: String
    },
    computed: {
      label () {
        switch (this.type) {
          case 'id':
            return '工单号'

          case 'progress':
            return '工序进度'

          case 'color':
            return '颜色'

          case 'enterTime':
            return '进厂日期'

          case 'estimateDeliveryTime':
            return '预计交车'

          case 'sheetMetalWH':
            return '钣金工时'

          case 'paintArea':
            return '油漆幅数'

          case 'consultantName':
            return '服务顾问'

          case 'durationInFactory':
            return '进厂时长'

          case 'carNo':
            return '车牌号'

          case 'brandModel':
            return '车牌型号'

          case 'technicianName':
            return '当前技师'

          case 'teamName':
            return '当前工组'

          case 'status':
            return '状态'

          case 'statusReason':
            return '中断原因'
        }
        return 'unmatched'
      },
      durationInFactory () {
        return new Date().getLocalDays() - new Date(this.work.enterTime).getLocalDays() + 1 + ' 天'
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-progress-bar__innerText {
    color: black;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #e2e2e2;
    border-radius: 8px;
  }
  .rightTips{
    position: absolute;
    right: -20px;
    top: -16px;
    color: white;
    transform: rotate(40deg);
    width: 60px;
    height: 40px;
    line-height: 60px;
    background-color: #808080;
    text-align: center;
  }
</style>
